import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'app/hooks';
import type { IUser } from 'features/user/userAPI';
import { Role } from 'features/user/userAPI';
import { UsersStateProps } from 'features/users/usersSlice';
import { RootState } from '../app/store';

export const useUsers = (): UsersStateProps & {
  admins: IUser[];
  managers: IUser[];
  users: IUser[];
} => {
  const usersState = useAppSelector(
    (state: RootState) => state.site,
    shallowEqual,
  );

  const usersArray: IUser[] = usersState?.users ?? [];

  const admins: IUser[] = useMemo(() => {
    return usersArray.filter((u: IUser) =>
      Boolean(u?.roles?.includes(Role.admin)),
    );
  }, [usersArray]);

  const managers: IUser[] = useMemo(() => {
    return usersArray.filter((u: IUser) =>
      Boolean(
        u?.roles?.includes(Role.manager) || u?.roles?.includes(Role.admin),
      ),
    );
  }, [usersArray]);

  return useMemo(
    () => ({ ...usersState, admins, managers, users: usersArray }),
    [usersState, admins, managers, usersArray],
  );
};
